<template>
  <ErrorPage :title="`${statusCode}`" :description="description">
    <template #description>
      {{ description }}

      <template v-if="url">
        <br />
        <span class="block sm:text-3xl italic mt-2 sm:px-0 leading-tight">
          {{ url }}
        </span>
      </template>
    </template>
  </ErrorPage>
</template>

<script lang="ts" setup>
defineProps({
  version: {
    type: String,
    default: '',
  },
  statusCode: {
    type: Number,
    default: 404,
  },
  statusMessage: {
    type: String,
    default: 'Not Found',
  },
  description: {
    type: String,
    default: 'Sorry, the page you are looking for could not be found.',
  },
  url: {
    type: String,
    default: '',
  },
})
</script>
